//路由表
import React from 'react';
// import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom';

//组件
import { renderRoutes } from 'react-router-config';
import AuthentRouter from './authent-router';


// eslint-disable-next-line import/no-anonymous-default-export
const routers = [

    {
        path: '/home',
        component: AuthentRouter(React.lazy(() => import("../views/home"))),
        meta: {
            auth: true,  //验证
            showCrumb: true,  //面包屑
            crumbs: "首页"
        },
        //子路由
        routes: [
            /**
             * 首页
             * @author: gaosir
             * @date: 2021-03-26
            */
            {
                path: "/home/index",
                exact: true,
                component: React.lazy(() => import("../views/index")),
                meta: {
                    auth: true,  //验证
                    showCrumb: true,  //面包屑
                    crumbs: "首页"
                }
            },


            /**
             * 数据查询
             * @author: gaosir
             * @date: 2021-04-13
            */
            {
                path: "/home/dataFind",
                exact: true,
                component: React.lazy(() => import("../views/data-find")),
                meta: {
                    auth: true,  //验证
                    showCrumb: true,  //面包屑
                    crumbs: "数据查询"
                }
            },

            /**
             * 通道日志
             * @author: gaosir
             * @date: 2021-04-13
             */
            {
                path: "/home/aisleLog",
                exact: true,
                component: React.lazy(() => import("../views/aisle-log")),
                meta: {
                    auth: true,  //验证
                    showCrumb: true,  //面包屑
                    crumbs: "通道日志"
                }
            },


            /**
             * 采集点配置
             * @author: gaosir
             * @date: 2021-07-26
             */
            {
                path: "/home/patchSet",
                exact: true,
                component: React.lazy(() => import("../views/patch-set/option")),
                meta: {
                    auth: true,  //验证
                    showCrumb: true,  //面包屑
                    crumbs: "采集点配置"
                }
            },


            /**
             * 采集点配置-详情
             * @author: gaosir
             * @date: 2021-07-26
             */
            {
                path: "/home/patchDetail",
                exact: true,
                component: React.lazy(() => import("../views/patch-set/detail")),
                meta: {
                    auth: true,  //验证
                    showCrumb: true,  //面包屑
                    crumbs: "采集点配置,采集点详情"
                }
            },


            /**
             * 采集点配置-详情 (空页面)
             * @author: gaosir
             * @date: 2021-07-26
             */
            {
                path: "/home/patchDetail2",
                exact: true,
                component: React.lazy(() => import("../views/patch-set/detail/indexEmpty")),
                meta: {
                    auth: true,  //验证
                    showCrumb: true,  //面包屑
                    crumbs: "采集点配置,采集点详情"
                }
            },


            /**
             * 参数配置
             * @author: gaosir
             * @date: 2021-04-13
             */
            {
                path: "/home/paramsConf",
                exact: true,
                component: React.lazy(() => import("../views/params-conf")),
                meta: {
                    auth: true,  //验证
                    showCrumb: true,  //面包屑
                    crumbs: "参数配置"
                }
            },


            /**
             * 统计分析
             * @author: gaosir
             * @date: 2021-04-13
             */
             {
                path: "/home/statistical",
                exact: true,
                component: React.lazy(() => import("../views/statistical")),
                meta: {
                    auth: true,  //验证
                    showCrumb: true,  //面包屑
                    crumbs: "统计分析"
                }
            },


            /**
             * 系统设置
             * @author: gaosir
             * @date: 2021-04-15
             */
            {
                path: "/home/setPswd",
                exact: true,
                component: React.lazy(() => import("../views/system/set-pswd")),
                meta: {
                    auth: true,  //验证
                    showCrumb: true,  //面包屑
                    crumbs: "系统设置"
                }
            },
        ]
    },
];

export default renderRoutes(routers)
